import React, { FunctionComponent, memo, ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import { IconProps } from './IconProps'

type Props = IconProps & {
    fontSize?: number
}

const NavigationBarIcon: FunctionComponent<Props> = ({
    color,
    name,
    fontSize = 18,
}): ReactElement => {
    return (
        <Grid noExpand>
            <FontelloIcon name={name} fontSize={fontSize} color={color} />
        </Grid>
    )
}

export default memo(NavigationBarIcon)
